/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

import { createElement, useEffect, useRef } from '@wordpress/element';
import { __ } from '@wordpress/i18n';


export default function Edit() {
	const dpiRef = useRef(null);
	const imageQualityRef = useRef(null);

	useEffect(() => {
		const refs = [dpiRef, imageQualityRef];

		refs.forEach((ref) => {
			const input = ref.current;

			if (input && !input.isInitialized) {
				input.isInitialized = true; // Prevent multiple initializations
				const min = input.getAttribute('min');
				const max = input.getAttribute('max');
				const value = input.value;

				// Initialize ionRangeSlider on the input element
				ionRangeSlider(input, {
					min: min,
					max: max,
					from: value,
					step: 1,
					grid: true,
					grid_num: 5,
					disable: true
				});
			}
		});
	}, []);


	return createElement(
		'div',
		null,
		<div className="solution__compress-pdf">
			<div className="solution__container__wrapper">
				<div className="solution__container">
					<div className="solution__header">{__('Compress PDF', 'compress-pdf')}</div>
					<div className="solution__form">
						<label htmlFor="file" className="solution__label">
							<span>{__('File:', 'compress-pdf')}</span>
							<input
								type="file"
								id="file"
								name="file"
								className="solution__file-input"
								required
								disabled
							/>
						</label>
						<label htmlFor="dpi" className="solution__label">
							<span>{__('DPI:', 'compress-pdf')}</span>
							<input
								ref={dpiRef}
								type="number"
								id="dpi"
								name="dpi"
								className="solution__input solution__range-linked"
								max={300}
								min={72}
								value={144}
								required
								disabled
							/>
							<span className="solution__hint">
								{__(
									'Dots per inch from 72 to 300. Smaller value reduces size of PDF File but also quality.',
									'compress-pdf'
								)}
							</span>
						</label>
						<label htmlFor="image-quality" className="solution__label">
							<span>{__('Image Quality:', 'compress-pdf')}</span>
							<input
								ref={imageQualityRef}
								type="number"
								id="image-quality"
								name="image-quality"
								className="solution__input .solution__range-linked"
								max={100}
								min={0}
								value={75}
								required
								disabled
							/>
							<span className="solution__hint">
								{__(
									'Values in % from 0 to 100. Smaller value reduces size of PDF File but also the quality.',
									'compress-pdf'
								)}
							</span>
						</label>
						<button disabled className="solution__btn">
							{__('Submit', 'compress-pdf')}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}

export const compressPDFIcon = createElement(
	'svg',
	{ width: 32, height: 33, viewBox: "0 0 32 33", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	createElement('rect', { y: "0.5", width: "32.0014", height: "32.0014", rx: "16.0007", fill: "#E5DBFF" }),
	createElement('path', { d: "M15.2597 24.2785V21.9081L14.0745 23.0933L13.0374 22.0563L16.0005 19.0932L18.9637 22.0563L17.9266 23.0933L16.7413 21.9451V24.2785H15.2597ZM10.0742 18.3525V16.871H21.9269V18.3525H10.0742ZM10.0742 16.1302V14.6487H21.9269V16.1302H10.0742ZM16.0005 13.9079L13.0374 10.9449L14.0745 9.90787L15.2597 11.0931V8.72266H16.7413V11.0931L17.9266 9.90787L18.9637 10.9449L16.0005 13.9079Z", fill: "#5A3BB2" })
);
